import { openMetadataApiClient } from '@/shared/api/core/axios-instance';
import { encodeOpenMetadataFqnSafe } from '@/shared/lib/format';
import type { TagLabel } from '@/shared/types';

export type ColumnSchema = {
  name: string;
  dataType: string;
  dataTypeDisplay?: string;
  description?: string;
  constraint?: 'PRIMARY_KEY' | 'FOREIGN_KEY' | 'UNIQUE' | 'NOT_NULL' | null;
  ordinalPosition?: number;
  dataLength?: number;
  fullyQualifiedName?: string;
  tags?: TagLabel[];
  children?: ColumnSchema[];
  customMetrics?: unknown[];
};

export type TableSchemaResponse = {
  data: ColumnSchema[];
  paging: {
    total: number;
  };
};

export const fetchTableSchema = async (fqn: string): Promise<ColumnSchema[]> => {
  const encodedFqn = encodeOpenMetadataFqnSafe(fqn);
  const response = await openMetadataApiClient.get<TableSchemaResponse>(`/tables/name/${encodedFqn}/columns`, {
    params: {
      limit: 50,
      offset: 0,
      fields: 'tags,customMetrics',
      include: 'all',
    },
  });

  return response.data.data || [];
};

export const fetchContainerSchema = async (fqn: string): Promise<ColumnSchema[]> => {
  const encodedFqn = encodeOpenMetadataFqnSafe(fqn);
  const response = await openMetadataApiClient.get(`/containers/name/${encodedFqn}`, {
    params: {
      fields: 'dataModel',
      include: 'all',
    },
  });

  return response.data?.dataModel?.columns || [];
};

export const fetchTopicSchema = async (fqn: string): Promise<ColumnSchema[]> => {
  const encodedFqn = encodeOpenMetadataFqnSafe(fqn);
  const response = await openMetadataApiClient.get(`/topics/name/${encodedFqn}`, {
    params: {
      fields: 'messageSchema',
      include: 'all',
    },
  });

  return response.data?.messageSchema?.schemaFields || [];
};
